module.exports = __webpack_public_path__ + "755c747c5055ea3e23f330a07ae7109a.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/news2.jpg
// module id = 198
// module chunks = 0